
class ArchiveBalade {
  private body: HTMLElement = document.body;


  private openButton: HTMLButtonElement | null;
  private closeButton: HTMLButtonElement | null;
  private filterPanel: HTMLElement | null;
  private overlay: HTMLElement | null;

  constructor() {
    this.openButton = document.querySelector('[data-btn-filter]');
    this.closeButton = document.querySelector('[data-filters-close]');
    this.filterPanel = document.querySelector('[data-filters]');
    this.overlay = document.querySelector('[data-filters-overlay]');

    if (!this.openButton || !this.closeButton || !this.filterPanel || !this.overlay) {
      return;
    }
    this._initPopin();
    this._initForm();

  }
  // Popin
  private _initPopin() {

    this.openButton!.addEventListener('click', () => this.openFilters());

    this.closeButton!.addEventListener('click', () => this.closeFilters());

    this.overlay!.addEventListener('click', () => this.closeFilters());
  }

  private openFilters(): void {
    this.filterPanel?.classList.add('active');
    this.overlay?.classList.add('active');
    this.body.classList.add('unscrollable');

  }

  private closeFilters(): void {
    this.filterPanel?.classList.remove('active');
    this.overlay?.classList.remove('active');
    this.body.classList.remove('unscrollable');
  }
  // Form
  private _initForm() {
    const filterButton = this.filterPanel?.querySelector('button[type="submit"]');
    const allItems = document.querySelectorAll<HTMLElement>('.archive-balade__item');
    const noResultsMessage = document.querySelector('.archive-balade__empty');

    if (!filterButton || allItems.length === 0) {
      return;
    }
    const filterResults = () => {
      const distanceInput = document.querySelector('#distance') as HTMLInputElement;
      const durationInput = document.querySelector('#duration') as HTMLInputElement;
      const difficultyInput = document.querySelector('input[name="difficulty"]:checked') as HTMLInputElement;
      const itemNotification = document.querySelector('[data-item-notifications]') as HTMLElement;

      const distanceMax = distanceInput ? parseInt(distanceInput.value, 10) : 0;
      const durationMax = durationInput ? parseInt(durationInput.value, 10) : 0;
      const difficultyValue = difficultyInput ? difficultyInput.value : null;

      let visibleItemsCount = 0;

      allItems.forEach(item => {
        if (item instanceof HTMLElement) {
          const itemDistance = parseInt(item.dataset.itemDistance ?? '0', 10);
          const itemDuration = parseInt(item.dataset.itemDuree ?? '0', 10);
          const itemDifficulty = item.dataset.itemDifficulty;

          const isDistanceMatch = itemDistance <= distanceMax;
          const isDurationMatch = itemDuration <= durationMax;

          // Pour la difficulté : soit aucun filtre n'est sélectionné, soit la difficulté correspond
          const isDifficultyMatch = !difficultyValue || itemDifficulty === difficultyValue;

          // L'article est visible SEULEMENT si TOUTES les conditions sont vraies
          if (isDistanceMatch && isDurationMatch && isDifficultyMatch) {
            item.classList.add('active')
            visibleItemsCount++;
          } else {
            item.classList.remove('active')
          }
        }
      });

      console.log(visibleItemsCount)
      if (noResultsMessage) {
        noResultsMessage.classList.toggle('active', visibleItemsCount === 0);
        itemNotification.classList.toggle('active', visibleItemsCount >= 1);
      }
    };

    filterButton.addEventListener('click', (event) => {
      event.preventDefault();
      filterResults();
      this.closeFilters();
    });

  }
}

export const archiveBalade = new ArchiveBalade();
